export default __webpack_public_path__ + "static/media/computer-lab-2.812118ce.jpg";